
import { Component, Vue, Prop } from "vue-property-decorator";
import EventAlarmTags from "./EventAlarmTags.vue";
import { namespace } from "vuex-class";
import GenericAdvancedTooltip from '../generic-advanced-tooltip/GenericAdvancedTooltip.vue';

const SiteMonitor = namespace("siteMonitor");

@Component({
	components: {
		"event-alarm-tags": EventAlarmTags,
		"generic-advanced-tooltip": GenericAdvancedTooltip
	}
})
export default class EventAlarmTagsToolTip extends Vue {
	@Prop({ type: Boolean, default: false })
	readonly value: boolean;

	@Prop(Number) readonly eventId: number;
	@Prop(Number) readonly groupId: number;

	private get isTooltipVisible(): boolean {
		return this.value;
	}

	private set isTooltipVisible(value: boolean) {
		this.$emit("input", value);
	}

	private closeTooltip(): void {
		this.isTooltipVisible = false;
	}
}
